import { TReportsListItemProps } from "../../../Types";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ReportTitleTexts from "./report-title-texts";
import ReportTitleDateAndNumber from "./report-title-date-and-number";
import getReportDetailVisibleByIDStore from "../../../stores/reports-store/ReportDetailVisibleByIDStore";
import ET3Div from "../../../core/et3-div";

const ReportTitles = withLiteObserverAndTheme<TReportsListItemProps>(
  (props) => {
    const {
      report,
      status,
      pageName,
      eventID,
      takenActionType,
      date,
      reportNumberFromPartition,
      reportsPartitionMaxNumber,
      theme
    } = props;
    const { colors } = theme;
    const isDetailVisible = getReportDetailVisibleByIDStore(
      report.reportId
    ).isDetailVisible.get();

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={1500}
        height={70}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.white}
        style={{
          borderTop: `1px solid ${colors.all.lightGray}`,
          color: colors.all.blue,
          cursor: "pointer"
        }}
        onClick={() =>
          getReportDetailVisibleByIDStore(report.reportId).isDetailVisible.set(
            !isDetailVisible
          )
        }
      >
        <ReportTitleTexts
          report={report}
          pageName={pageName}
          takenActionType={takenActionType}
        />
        <ReportTitleDateAndNumber
          report={report}
          pageName={pageName}
          takenActionType={takenActionType}
          status={status}
          eventID={eventID}
          date={date}
          reportNumberFromPartition={reportNumberFromPartition}
          reportsPartitionMaxNumber={reportsPartitionMaxNumber}
        />
      </ET3Div>
    );
  }
);
export default ReportTitles;
